<template>
  <div class="container">
    <Modal :title="modalTitle" :show="modalVisible" @hideModal="hideModal" @submit="hideModal">
      <div class="announcement-modal-body">
        <p>近期公司接到群众反馈，有不法分子通过社交媒体平台冒用我司名义发布虚假信息。为打击违法犯罪行为，避免广大用户利益受损，公司特此澄清如下：</p>
        <p>1、我司从未在网站或社交媒体平台上以任何形式发布过"做任务赢取奖励"或类似信息，也未曾授权任何机构或个人实施此类行为。</p>
        <p>2、广大互联网用户应提高防骗意识，识别互联网上的虚假信息或诈骗信息，拒绝向陌生人透露个人信息及银行、财务信息。</p>
        <p>3、针对盗用我司名义在网上发布虚假信息或实施诈骗的行为，我司将依法追究相关人员的法律责任，积极维护网络环境，保护自身及广大用户权益。</p>
        <p>4、提醒广大用户通过我司官方渠道（官方网站、官方APP、官方微信公众号等）了解招聘信息、业务合作等事宜。如有自称我司员工的人员联系您，可拨打我司官方客服电话进行确认。请勿轻易点击来源不明的链接或下载不明来源的文件，以防感染病毒或泄露个人信息。</p>
        <p>如发现任何可疑行为或接到可疑电话、信息，请及时向当地公安机关报案，并将相关线索提供给我司。</p>
        <p>再次感谢广大用户对我司的信任与支持。我们将一如既往地为您提供优质、安全、可靠的服务。</p>
        <p>&nbsp;</p>
        <p style="text-align: right;">优矩互动（北京）科技有限公司</p>
        <p style="text-align: right;">2024年6月7日</p>
      </div>
    </Modal>
    
    <!-- 使用Navbar组件 -->
    <Navbar 
      :language="language" 
      @language-change="setLanguage"
      @scroll-to-section="scrollToSection" 
    />
    
        <router-view :language="language" ref="routerView" />
  </div>
</template>
<script>
import Modal from '../components/Modal.vue'
import Navbar from '../components/Navbar.vue'

const setWithExpiry = (key, value, ttl) => {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  }
  localStorage.setItem(key, JSON.stringify(item))
}
const getWithExpiry = key => {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}
const isModalVisible = () => {
  const modalVisible = getWithExpiry('modalVisible')
  if (modalVisible === null) {
    setWithExpiry('modalVisible', true, 1000 * 60 * 60 * 24 * 14)
    return true
  }
  return false
}

export default {
  components: {
    Modal,
    Navbar
  },
  data () {
    return {
      modalTitle: '警惕网络诈骗，保护个人信息安全',
      modalVisible: isModalVisible(),
      language: this.$cookies.get('websiteLanguage') || 'ch'
    }
  },
  methods: {
    hideModal () {
        this.modalVisible = false
    },
    setLanguage (val) {
      this.language = val
      this.$cookies.set('websiteLanguage', val)
      this.$refs.routerView.getLanguage(val)
    },
    scrollToSection(sectionId) {
      console.log('尝试滚动到:', sectionId)
      // 调用index.vue中的全屏滚动方法
      if (this.$refs.routerView && this.$refs.routerView.getOffsetTop) {
        this.$refs.routerView.getOffsetTop(sectionId)
      } else {
        console.error('找不到routerView或getOffsetTop方法')
      }
    }
  }
}
</script>

<style>
/* 重置样式 */
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

a{
    text-decoration: none;
}

html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
}

body{
    min-width: 1200px;
    overflow-x: auto;
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    background: #fff;
    color: #333;
    line-height: 1.6;
}

.container{
    padding: 0;
    margin: 0;
    width: 100%;
}

/* 移动端适配 */
@media screen and (width <= 768px) {
    body {
        min-width: auto; /* 移动端取消最小宽度限制 */
        overflow-x: hidden; /* 移动端隐藏水平滚动条 */
    }
    
    .copyright {
        padding: 30px 20px;
        font-size: 13px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/App.vue